import { render, staticRenderFns } from "./transactionReason.vue?vue&type=template&id=20e38861&scoped=true"
import script from "./transactionReason.vue?vue&type=script&lang=js"
export * from "./transactionReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e38861",
  null
  
)

export default component.exports